import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';
import { isNotEmptyString } from '@racemap/utilities/functions/utils';
import type { FC } from 'react';
import { useCountSearchedTrackers } from '../../../lib/customHooks';
import { SearchBar } from '../../BasicComponents/SearchBar/SearchBar';

export type Props = {
  searchValue: string;
  setSearchValue: (newSearchValue: string) => Promise<void>;
};

export const SearchBarAndResultsCount: FC<Props> = ({ searchValue, setSearchValue }) => {
  const searchResultsCount = useCountSearchedTrackers();

  const additionalInfoSearchBar =
    'Search for multiple trackers by separating their names with a comma. This includes searching by ICCIDs and IMEI numbers too.';

  const hasSearchResults = isNotEmptyString(searchValue);

  return (
    <SearchBarAndSearchResultsCountContainer>
      <TableOptionsContainer>
        <SearchBar
          additionalInfo={additionalInfoSearchBar}
          value={searchValue}
          onChange={setSearchValue}
          size="sm"
        />
      </TableOptionsContainer>
      {hasSearchResults && (
        <SearchResultsCount>{`${searchResultsCount} ${
          searchResultsCount === 1 ? 'result' : 'results'
        }`}</SearchResultsCount>
      )}
    </SearchBarAndSearchResultsCountContainer>
  );
};

const SearchBarAndSearchResultsCountContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 390px;
`;

const SearchResultsCount = styled.div`
  text-align: right;
  white-space: nowrap;
  font-size: 0.8em;
  color: ${RacemapColors.DarkGray};
`;

const TableOptionsContainer = styled.div`
  width: clamp(150px, 300px, 400px);
  margin-right: 10px;

  .input-group,
  .input-group-append,
  .form-control:not(textarea) {
    height: 25px;
  }
`;
